import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSnackbar } from "react-simple-snackbar";
import Loader from "../components/Loader";
import logo from "../assets/logo.png";

const QrExit = () => {
	let { id } = useParams();
	const navigate = useNavigate();
	const [transaction, setTransaction] = useState(null);
	const [loading, setLoading] = useState(true);

	const [dangerSnackbar] = useSnackbar({
		style: {
			zIndex: 10,
			backgroundColor: "#d81e5b",
			color: "#fff",
		},
	});

	const getData = async (e) => {
		setLoading(true);
		const requestOptions = {
			method: "GET",
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/transactions/t/${id}`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			dangerSnackbar("Something went wrong.");
		} else {
			setTransaction(data.transaction);
			getStatus();
		}
		setLoading(false);
	};

	const getStatus = async () => {
		const requestOptions = { method: "GET" };

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/transactions/t/${id}`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			dangerSnackbar("Something went wrong.");
		} else {
			if (data.transaction.status === "In") {
				setTimeout(function () {
					getStatus();
				}, 1000);
			} else {
				navigate(`/finish`);
			}
		}
	};

	useEffect(() => {
		getData();
	}, []);

	return loading ? (
		<Loader className="full full-page bg-white" />
	) : (
		<div className="content full-page flex-column bg-white">
			<img src={logo} alt="logo" className="qr-logo" />
			<h1 className="text-xl text-medium-inter">Exit Code</h1>
			<p className="qr-instruction align-center text-sm m-0">
				Please show this QR code to the gate security upon exit.
			</p>
			<img
				src={transaction.exit_code_path}
				alt="Exit Code"
				className="qr-img"
			/>
			<span className="text-lg text-medium-inter">{transaction.exit_code}</span>
		</div>
	);
};

export default QrExit;
